import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/HeroSection';
import { FeatureGrid } from '../components/FeatureGrid';
import { RoadmapSection } from '../components/RoadmapSection';
import { BlogPreview } from '../components/BlogPreview';
import { SEO } from '../components/SEO';

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="UrbanHive - Apiculture Urbaine & Ruches de Balcon | Guide Complet 2025"
        description="Découvrez l'apiculture urbaine avec UrbanHive. Guide complet pour installer votre ruche sur balcon, produire 10-15kg de miel par an et contribuer à la sauvegarde des abeilles en ville."
        keywords="apiculture urbaine, ruche balcon, apiculture ville, miel urbain, abeilles ville, ruche urbaine, apiculture débutant, guide apiculture 2025"
        url="/"
        image="https://urban-hive.fr/images/ruche-balcon.png"
      />
      <Header />
      <main>
        <HeroSection />
        <FeatureGrid />
        <RoadmapSection />
        <BlogPreview />
      </main>
      <Footer />
    </div>
  );
};
